import type { ModeId } from '@wot/shared';

// Each mode is a personality: its own color, icon, and one punchy line.
// Home's chips and the Solo Setup's mode cards read from the same table so
// a mode looks the same wherever it appears.
export const MODE_STYLE: Record<ModeId, { line: string; color: string; bright: string; icon: string }> = {
  RUSH: {
    line: '7 questions. Speed pays.',
    color: '#14B8A6', bright: '#2DD4BF',
    icon: 'M13 2 3 14h7l-1 8 11-12h-7l0-8z',
  },
  CLIMB: {
    line: 'Easy to hard. Ranked.',
    color: '#3E7BFA', bright: '#7EA8FF',
    icon: 'M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z',
  },
  SURVIVAL: {
    line: '3 lives. How deep?',
    color: '#F43F5E', bright: '#FB7185',
    icon: 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z',
  },
};
